/* eslint-disable consistent-return,max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import 'moment/locale/es';
// @material-ui/icons
import Check from '@material-ui/icons/Check';
// @material-ui/core components
import FilterStyles from 'assets/jss/AdsFilter';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import withStyles from '@material-ui/core/styles/withStyles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// global variables
import { exchangeRateStatus } from 'config';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import Button from 'components/UI/CustomButtons/Button';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import SectionDivider from 'components/common/SectionDivider/SectionDivider';

/**
 * Variable to define default selected status
 */
const defaultSelectedStatus = [
  exchangeRateStatus.ENABLED,
  exchangeRateStatus.DISABLED,
];

/**
 * @class
 * @extends React.Component
 */
class ExchangeRateFilter extends React.Component {
  constructor(props) {
    super(props);
    const { appliedFilter } = props;
    this.state = {
      selectedStatus:
        (appliedFilter && appliedFilter.status) || defaultSelectedStatus,
      localFilter: appliedFilter || null,
    };
  }

  /**
   * @description
   * Change filters.
   *
   * @param {Object} changedFilter - Changed filters values.
   * @returns {*} - No returns value.
   */
  handleChangeFilter = changedFilter => {
    const { localFilter } = this.state;
    const { filter } = this.props;
    const filters = { ...localFilter, ...changedFilter };
    this.setState({ localFilter: filters });
    filter(filters);
  };

  /**
   * @description
   * Update new selection filter type.
   *
   * @param {string} filter - Filter type to update.
   * @param {*} callback - Callback waiting for setState.
   * @returns {*} - An update function.
   */
  updateSelectedCheckboxes = (filter, callback) => {
    const { selectedStatus } = this.state;
    switch (filter) {
      case 'status':
        return this.handleChangeFilter(
          selectedStatus.length === 0 || selectedStatus.length === 3
            ? { status: undefined }
            : { status: selectedStatus },
          callback,
        );
      default:
    }
  };

  /**
   * @description
   * Handle select status checkboxes.
   *
   * @param {string} checkLabel - Status selected.
   * @param {*} callback - Callback waiting for setState.
   * @returns {undefined} No return.
   */
  handleStatusCheck = (checkLabel, callback = null) => {
    const { selectedStatus } = this.state;
    if (selectedStatus.indexOf(checkLabel) !== -1) {
      const newSelected = selectedStatus.filter(
        status => status !== checkLabel,
      );
      this.setState({ selectedStatus: newSelected }, () =>
        this.updateSelectedCheckboxes('status', callback),
      );
    } else {
      this.setState(
        {
          selectedStatus: [...selectedStatus, checkLabel],
        },
        () => this.updateSelectedCheckboxes('status', callback),
      );
    }
  };

  /**
   * @description
   * Render full filter's box.
   * @returns {*} - ExchangeRateFilter's box.
   */
  render() {
    const { classes, restartFilters, t } = this.props;
    const { selectedStatus } = this.state;
    return (
      <div className={classes.expandFilters} style={{ marginBottom: 20 }}>
        <GridContainer>
          <GridItem xs={12}>
            <div style={{ padding: '0px 10px 10px 10px' }}>
              <GridContainer style={{ marginTop: '15px' }}>
                <GridItem xs={12} md={4}>
                  <GridItem>
                    <SectionDivider
                      label={t('exchange_rate.filters.section.status')}
                    >
                      <GridItem>
                        <FormControlLabel
                          control={
                            <Checkbox
                              className={classes.checked}
                              onClick={() =>
                                this.handleStatusCheck(
                                  exchangeRateStatus.ENABLED,
                                )
                              }
                              checked={
                                selectedStatus.indexOf(
                                  exchangeRateStatus.ENABLED,
                                ) !== -1
                              }
                              checkedIcon={
                                <Check className={classes.checkedIcon} />
                              }
                              icon={<Check className={classes.uncheckedIcon} />}
                            />
                          }
                          id="statusEnabledCheckbox"
                          label={t('exchange_rate.list.status.enabled')}
                          style={{ width: '100%' }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              className={classes.checked}
                              onClick={() =>
                                this.handleStatusCheck(
                                  exchangeRateStatus.DISABLED,
                                )
                              }
                              checked={
                                selectedStatus.indexOf(
                                  exchangeRateStatus.DISABLED,
                                ) !== -1
                              }
                              checkedIcon={
                                <Check className={classes.checkedIcon} />
                              }
                              icon={<Check className={classes.uncheckedIcon} />}
                            />
                          }
                          id="statusDisabledCheckbox"
                          label={t('exchange_rate.list.status.disabled')}
                          style={{ width: '100%' }}
                        />
                      </GridItem>
                    </SectionDivider>
                  </GridItem>
                </GridItem>
              </GridContainer>
            </div>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer justify="flex-end">
              <GridItem>
                <Button
                  color="danger"
                  simple
                  className={classes.buttons}
                  onClick={() => {
                    this.setState({
                      selectedStatus: defaultSelectedStatus,
                      localFilter: {},
                    });
                    restartFilters();
                  }}
                  id="restartFilters"
                  key="restartFilters"
                >
                  {t('ad.filters.clean')}
                </Button>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

/**
 * PaidAdFilter PropTypes
 * @param classes - styles received from withStyles
 * @param appliedFilter - prop to know applied filters
 * @param t - prop from HOC with string translations
 * @param i18n - prop from HOC with string translations
 * @callback filter - callback called when user clicks filter button
 * @callback restartFilters - callback called when user restart filters button
 */

ExchangeRateFilter.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  appliedFilter: PropTypes.shape({}).isRequired,
  filter: PropTypes.func.isRequired,
  restartFilters: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(withStyles(FilterStyles)(ExchangeRateFilter));
